module.exports = __webpack_public_path__ + "static/media/battery_blue.e7dbfef7.svg";